import { render, staticRenderFns } from "./IconDocumentText.vue?vue&type=template&id=71a04ae3&"
import script from "./IconDocumentText.vue?vue&type=script&lang=js&"
export * from "./IconDocumentText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports